import { css } from 'styled-components'
import { colors } from '../vars/colors.style'

export const slickTheme = css`
  .slick-track {
    display: flex;
  }

  .slick-dots {
    display: flex !important;
    align-items: center;
    justify-content: center;
    margin-top: 2.1rem;
    list-style: none;

    li {
      height: 0.6rem;

      + li {
        margin-left: 0.4rem;
      }
    }

    button {
      width: 0.6rem;
      height: 0.6rem;
      padding: 0;
      overflow: hidden;
      whitespace: nowrap;
      text-indent: 100%;
      background-color: transparent;
      border: 0.1rem solid ${colors.light};
      border-radius: 50%;
      opacity: 0.5;
      transition: all 0.15s ease;
    }

    .slick-active button {
      background-color: ${colors.light};
      opacity: 1;
    }
  }
`
